import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes.js'
import { i18nPromise } from '@/plugins/i18n.js'

export const routerPromise = i18nPromise
    .then(i18n => {
      Vue.use(Router)
      const router = new Router({
        routes,
        mode: 'history'
      })

      router.beforeEach((to, from, next) => {
        if (to.path.startsWith("/legal")) return next();
        const lang = to.params.lang
        //if (!['en', 'de', 'fr', 'pt'].includes(lang)) return next('en')
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        fetch(`https://api.crowdl.io/ratemytactic/cdn/${lang}.json`)
        .then(response => response.json())
        .then((msgs) => {
          i18n.setLocaleMessage(lang, msgs.default || msgs);
          i18n.locale = lang;
          return next();
        })
        .catch((err) => {
          console.error(err);
          return next('en');
        })
      })
      return router;
    })
